import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c23035e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-15" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pt-lg-10 mb-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-4x text-gray-800 mb-10" }, "System Error", -1))
const _hoisted_6 = { class: "fw-bold fs-3 text-muted mb-15 pre-line" }
const _hoisted_7 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "mb-10 pt-lg-10"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: "Logo",
            src: _ctx.themeLightLogoIconText,
            class: "h-40px mb-5"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.I18nUtils.translate("sea.pages.error500.description")), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "btn btn-lg btn-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.pages.error500.back")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px",
        style: _normalizeStyle({
          backgroundImage: 'url(' + _ctx.getIllustrationsPath('17.png') + ')',
        })
      }, null, 4)
    ])
  ]))
}